export default "__VITE_ASSET__WPiXoX0Y__"